import { Typography } from '@mui/material';
import { EventsContext } from '../context';
import CacheUpdater from './CacheUpdater';
import LoadingIndicator from './LoadingIndicator';
import { queryEvents } from 'src/schema';

interface Props {
    children: React.ReactNode;
}

export default function EventsProvider(props: Props) {
    const { data, isLoading, error } = queryEvents();

    if (isLoading) {
        return <LoadingIndicator message="Loading event data..." />;
    }

    if (error) {
        return <Typography>Oh no! {JSON.stringify(error)}</Typography>;
    }

    const eventsList = data?.events || [];
    const eventGroupsList = data?.eventGroups || [];
    const eventsMap = new Map();
    const eventGroupsMap = new Map();

    for (let event of eventsList) {
        eventsMap.set(event.id, event);
    }

    for (let eventGroup of eventGroupsList) {
        eventGroupsMap.set(eventGroup.id, eventGroup);
    }

    return (
        <EventsContext.Provider value={{ events: eventsMap, eventGroups: eventGroupsMap }}>
            {props.children}
            <CacheUpdater />
        </EventsContext.Provider>
    );
}
